module.exports = __webpack_public_path__ + "media/customizations/riverstone/back-2575207b97b5afe59ef4e9dd7c7c8ccc.jpg";